// Prikaz iznosa: dvije decimale, zarez kao decimalni znak, tocka kao razdjelnik
// tisucica. Isto za hrvatski i engleski, jer se u aplikaciji tako i knjizi.
//
// NIKAD ne smije ispisati "NaN". Iznos se prikazuje na obrascima, u popisima i
// na ispisima racuna - "NaN" ondje nije samo ruzan nego izgleda kao da je s
// dokumentom nesto ozbiljno krivo. Prije se to dogadjalo cim vrijednost nije
// bila broj:
//
//   undefined  -> "NaN"   (polje koje jos nije popunjeno na novom dokumentu)
//   "abc"      -> "NaN"
//   NaN        -> "NaN"
//   Infinity   -> "Infinity"   (dijeljenje s nulom kod tecaja)
//
// Sto nije broj, prikazuje se kao 0,00. Prava vrijednost, ako je ima, i dalje
// stoji u polju iznad - podnozje je samo zbroj i ne smije izmisljati brojku.

const uBroj = (vrijednost) => {
  if (typeof vrijednost === 'number') {
    return isFinite(vrijednost) ? vrijednost : 0
  }
  if (vrijednost === null || vrijednost === undefined) { return 0 }
  const tekst = String(vrijednost).trim()
  if (tekst === '') { return 0 }
  const broj = Number(tekst)
  // Namjerno se ne pogadja decimalni znak: iz "1.234" se ne zna je li tisucu
  // dvjesto ili jedan cijela. Bolje 0,00 nego izmisljen iznos.
  return isFinite(broj) ? broj : 0
}

const moneyFormat = (value) => {
  const val = uBroj(value).toFixed(2).replace('.', ',')
  return val.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export default moneyFormat
